import { h } from 'preact';
import CartItem from '../cartItem'
import Scrollbar from 'react-scrollbars-custom';

import Helmet from "preact-helmet";

const Cart = ({onHide, onChange, cart}) => (
  
  <div class="cart js-active">
      
    <Helmet
              htmlAttributes={{lang: "en", amp: undefined}} // amp takes no value
              title="cart"
               titleTemplate="%s" />
   <div class="btn--closeLay" onClick={onHide}></div>
      <button class="btn--close" onClick={onHide}>
     close 
      </button>

    <div class="cart-form">
    <Scrollbar className="insideCart" style={ {width: '100%', minHeight: 300} } >
    <div class="cart-bottom">
        <div class="cart-info clearfix cart-section">
          <div class="cart-info__pricing">
            <span class="cart-info__small cart-info__total"><small>USD</small></span>
            <span class="pricing pricing--no-padding">${cart.totalPrice}</span>
          </div>
        </div>
        <div class="cart-actions-container cart-section type--center">
          <div class="cart-discount-notice cart-info__small"><small>Shipping and taxes are added at checkout.</small></div>
          <div class="cart-discount-notice cart-info__small red"><small>all sales final, no returns or refunds.</small></div>
       
          <br />
          <div><a href={cart.webUrl} target="_blank" class="btn btn--cart-checkout">Checkout</a></div>
        </div>
      </div>
     
      <div class="cart-item-container cart-section">
    
        {cart.lineItems && cart.lineItems.map((item, i) => <CartItem item={item} onChange={onChange} />)}
      </div>

     </Scrollbar>
    </div>

  </div>
)



export default Cart



// WEBPACK FOOTER //
// ./components/shpfybtn/cart/index.js